export enum AI_SOURCES {
  tavus = 'tavus',
  synthesia = 'synthesia',
  personal_avatar = 'personal_avatar',
}
